import {Scope} from 'Shared/constants/Scope';
import {Application} from 'Users/models/Application';

export const extractApplicationIdsFromScope = (scopes: Scope[], designatedScope: Scope) => {
  const applicationIds = new Set<number>();
  scopes.forEach(scope => {
    if (scope.includes(designatedScope)) {
      const splitted = scope.split('|');
      if (splitted && splitted.length === 2) {
        if (isNaN(Number(splitted[1]))) {
          splitted[1].split(',').forEach(x => applicationIds.add(Number(x)));
        } else {
          applicationIds.add(Number(splitted[1]));
        }
      }
    }
  });

  return Array.from(applicationIds);
};

export const hasAccessToScopeByApplication = (scopes: Scope[], designatedScope: Scope, application: Application) => {
  const applicationIds = extractApplicationIdsFromScope(scopes, designatedScope);
  return !!scopes.find(scope => scope.toString() === `${designatedScope}|*`) || applicationIds.includes(application);
};
